import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { isRenault } from '../util/constants';
// MUI
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography'

// Redux Actions
import { showError } from './../redux/snackbar'
import { nextStep, previousStep } from './../redux/step'
import { setLoading } from './../redux/loading'
import { setAppointment } from './../redux/appointment'

// Api Requests
import { sendVerificationCodeWOLogin, createAppointment } from './../services/index'

// Custom
import PhoneInput from './../components/PhoneInput'
import CustomCard from './../components/CustomCard'
import SummaryContent from './SummaryContent'

// Styles
const styles = {
    formRoot: {
        width: '100%'
    }
}

// Spacing
const spacingRoot = { xs: 2, sm: 2, md: 2, lg: 3, xl: 4 }

function FunctionalComponent(props) {

    // Props
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const portLogin = useSelector(state => state.portLogin)
    const form = useSelector(state => state.form)
    const appointment = useSelector(state => state.appointment)
    const utmValues = useSelector(state => state.utmValues)
    const vehicle = useSelector(state => state.vehicle)
    const loading = useSelector(state => state.loading)

    // Media query screen size
    const theme = useTheme();
    const xsDown = useMediaQuery(theme.breakpoints.down('sm'));
    const smDown = useMediaQuery(theme.breakpoints.down('md'));
    const mdDown = useMediaQuery(theme.breakpoints.down('lg'));
    const lgDown = useMediaQuery(theme.breakpoints.down('xl'));
    const xlDown = useMediaQuery(theme.breakpoints.down('xl'));

    // Calculate spacing 
    const spacingForm = useMemo(() => {

        const spacings = { xs: 2, sm: 2, md: 3, lg: 3, xl: 4 }

        if (xsDown) {
            return spacings.xs
        }
        else {
            if (smDown) {
                return spacings.sm
            }
            else {
                if (mdDown) {
                    return spacings.md
                }
                else {
                    if (lgDown) {
                        return spacings.lg
                    }
                    else {
                        if (xlDown) {
                            return spacings.xl
                        }
                        else {
                            return spacings.xl
                        }
                    }
                }
            }
        }

    }, [xsDown, smDown, mdDown, lgDown, xlDown]);

    // Previous step
    function handleBackButton() {
        dispatch(previousStep())
    }

    // Next step
    function handleNextStep() {

        if (loading) {
            return
        }

        // Set loading
        dispatch(setLoading(true))



        const body = {
            vehicleInfo: form.vehicleInfo,
            km: form.km,

            // Renaming some fields for request
            notes: form.appointmentRequests,
            dealerId: form.dealer.id,
            appointmentDate: form.timeSlot.date,
            timeSlot: form.slot,

            requestValeService: form.vale,
            phone: form.phone.replace(/[^0-9]/g, ''),
            name: form.name,
            surname: form.surname,
            email: form.email,
            permission: form.permission,
            phonePermission: form.phonePermission,
            smsPermission: form.smsPermission,
            emailPermission: form.emailPermission,
            vehicleModel: form.vehicleModel,
            utmCampaign: utmValues.utmCampaign,
            utmMedium: utmValues.utmMedium,
            utmSource: utmValues.utmSource,
            origin: utmValues.origin,
            campaign: utmValues.campaign,
            platform: utmValues.platform
        }

        // Send sms to customer and create appointment
        createAppointment(body, portLogin)
            .then(appointment => {

                // Set appointment
                dispatch(setAppointment(appointment))

                dispatch(nextStep())
            })
            .catch(e => {
                console.error(e)
                let code = e?.code ?? 0
                let msg = code === 1170 ? e.message : t('UNKNOWN_ERROR')
                dispatch(showError(msg))
            })
            .finally(() => {
                dispatch(setLoading(false))
            })


    }

    //GA DataLayer
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'formSteps',
            'pageName': isRenault ? 'Renault_Servis_Randevusu' : 'Dacia_Servis_Randevusu',
            'businessType': 'after-sales',
            'pageType': 'form',
            'formName': 'Online Servis Randevusu',
            'formType': 'service-request',
            'formCategory': 'lead-after-sales',
            'formStepName': 'step-4',
            'formStepNumber': 'step-4',
            'vehicleId': portLogin ? vehicle.id : "",

            'vehicleModel': portLogin ? vehicle.modelName : form.vehicleModel,
            'dealerName': form.dealer.name,
            'dealerId': form.dealer.id



        });

    }, [])
    // On mount

    // Forms
    const [smsCode, setSmsCode] = useState('');

    // Form errors
    const [smsCodeError, setSmsCodeError] = useState(false);

    const [verifyButton, setVerifyButtonColor] = useState('inherit');

    // Handle sms verify
    function handleSmsVerify() {

        if (loading) {
            return
        }

        // Form validation
        let error = false;
        if (!smsCode || smsCode.replace(/\s/g, '').length !== 5) {
            error = true
            setSmsCodeError(true)
        }

        // Don't proceed if there is an error 
        if (!error) {



            // Set loading
            dispatch(setLoading(true))

            // Get customer info
            sendVerificationCodeWOLogin(appointment.id, { code: smsCode.replace(/\s/g, ''), phone: form.phone.replace(/[^0-9]/g, '') })
                .then(() => {

                    // Next step
                    dispatch(nextStep())
                })
                .catch(e => {
                    if (e instanceof Error) {
                        console.error(e)
                        dispatch(showError(t('UNKNOWN_ERROR')))
                    }
                    else {
                        dispatch(showError('Girdiğiniz Kod Hatalı'))
                    }
                })
                .finally(() => {
                    dispatch(setLoading(false))
                })

        }
    }

    function onChangeSmsCode(value) {
        if (!value || !value.match(/[0-9]\s*[0-9]\s*[0-9]\s*[0-9]\s*[0-9]/g)) {
            setVerifyButtonColor('inherit')
        } else {
            setVerifyButtonColor('secondary')
        }
    }

    function getCardContent() {
        return (
            <form className={styles.formRoot} noValidate autoComplete="off">
                <Grid container spacing={spacingForm}>
                    {/* Title */}
                    <Grid item xs={12}>
                        <Typography variant='h6' color='textPrimary'>
                            {t('smsCode')}
                        </Typography>
                    </Grid>

                    {/* Sms */}
                    <Grid item xs={12}>
                        <PhoneInput
                            state={smsCodeError ? 'error' : ''}
                            error={smsCodeError}
                            helperText={smsCodeError ? t('smsCodeError') : null}
                            fullWidth
                            center
                            placeholder='X X X X X'
                            variant='outlined'
                            value={smsCode}
                            onChange={e => {

                                let value = e.target.value.replace('/\s/g', '')
                                onChangeSmsCode(value);
                                setSmsCode(value);
                                if (value) setSmsCodeError(false)
                            }}
                            mask='9 9 9 9 9'
                        />
                    </Grid>
                </Grid>
            </form>
        )
    }

    function getCardContentPortLogin() {
        return (
            <form className={styles.formRoot} noValidate autoComplete="off">
                <SummaryContent />
            </form>
        )
    }

    function getCardActions() {
        return (
            <Box display='flex' justifyContent='space-between'>
                {
                    !portLogin &&
                    <>
                        <Grid item xs={12} container justifyContent='space-between'>
                            <Button
                                variant="contained"
                                sx={styles.button}
                                onClick={handleBackButton}
                                style={{ width: xsDown ? '40%' : '170px', minWidth: "120px", minHeight: '42px', boxShadow: 'none' }}
                            >
                                {t('backButtonSms')}
                            </Button>
                            <Button variant="contained" color={verifyButton} style={{ width: xsDown ? '40%' : '170px', minWidth: "120px", minHeight: '42px', boxShadow: 'none', marginLeft: '5px' }} onClick={handleSmsVerify}>
                                {t('verifySmsAndFromButton')}
                            </Button>
                        </Grid>
                    </>
                }
                {
                    portLogin &&
                    <>
                        <Button
                            variant="contained"
                            sx={styles.button}
                            onClick={handleBackButton}
                            style={{ minWidth: '105px' }}
                            disableElevation
                        >
                            {t('backButton')}
                        </Button>
                        <Button variant="contained" color="primary" style={{ minWidth: '105px' }} disableElevation onClick={handleNextStep}>
                            {t('takeAppointmentButton')}
                        </Button>
                    </>
                }
            </Box>
        );
    }

    return (
        <CustomCard
            padding={spacingRoot}
            content={!portLogin ? getCardContent() : getCardContentPortLogin()}
            action={getCardActions()}
        />
    )
}

// Connect redux and translation
export default FunctionalComponent